var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-sheet",
    { staticClass: "rounded-xl my-6 subscription-page-container" },
    [
      _c(
        "div",
        { staticClass: "scrolling-content" },
        [
          _c(
            "v-container",
            { staticClass: "fill-height" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", lg: "5" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-8 text-center rounded-lg",
                          attrs: { outlined: "" },
                        },
                        [
                          _vm.isLoading
                            ? _c(
                                "div",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: "64",
                                    },
                                  }),
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-h5 font-weight-bold text--primary mt-6",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.PaymentSuccess.confirming"
                                            ) || "Confirming Payment..."
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-body-1 text--secondary mt-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.PaymentSuccess.pleaseWait"
                                            ) ||
                                              "Please wait while we confirm your payment."
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm.isSuccess
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "80",
                                        color: "green darken-1",
                                      },
                                    },
                                    [_vm._v("mdi-check-circle-outline")]
                                  ),
                                  _c(
                                    "h1",
                                    {
                                      staticClass:
                                        "text-h4 font-weight-bold text--primary mt-6",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.PaymentSuccess.title"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-body-1 text--secondary mt-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PaymentPage.PaymentSuccess.description"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-divider", { staticClass: "my-6" }),
                                  _vm.orderId && _vm.amount > 0
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "text-h6 font-weight-semibold text--primary mb-4",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "PaymentPage.PaymentSuccess.transactionDetails"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("v-simple-table", {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function () {
                                                    return [
                                                      _c("tbody", [
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-left text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "PaymentPage.PaymentSuccess.orderId"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right text--primary font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.orderId
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-left text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "PaymentPage.PaymentSuccess.amountPaid"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right text--primary font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatKrw(
                                                                    _vm.amount
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-left text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "PaymentPage.PaymentSuccess.paymentKey"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right text--primary font-weight-medium text-truncate",
                                                              staticStyle: {
                                                                "max-width":
                                                                  "150px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.paymentKey
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              4133038650
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text mt-8",
                                      attrs: {
                                        to: "/",
                                        "x-large": "",
                                        depressed: "",
                                        color: "blue",
                                        block: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.PaymentSuccess.goToDashboard"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "80",
                                        color: "red darken-1",
                                      },
                                    },
                                    [_vm._v("mdi-alert-circle-outline")]
                                  ),
                                  _c(
                                    "h1",
                                    {
                                      staticClass:
                                        "text-h4 font-weight-bold text--primary mt-6",
                                    },
                                    [_vm._v("Payment Failed")]
                                  ),
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mt-6 text-left",
                                      attrs: {
                                        outlined: "",
                                        type: "error",
                                        border: "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.errorMessage) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-body-2 text--secondary mt-2",
                                    },
                                    [_vm._v("Order ID: " + _vm._s(_vm.orderId))]
                                  ),
                                  _c("v-divider", { staticClass: "my-6" }),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text mt-4",
                                      attrs: {
                                        to: { name: "SubscriptionPlan" },
                                        "x-large": "",
                                        depressed: "",
                                        color: "grey darken-3",
                                        block: "",
                                      },
                                    },
                                    [_vm._v(" Return to Plans ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "white--text mt-8",
                                      attrs: {
                                        to: "/",
                                        "x-large": "",
                                        depressed: "",
                                        color: "blue",
                                        block: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "PaymentPage.PaymentSuccess.goToDashboard"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "auth-layout-footer" },
            [_c("client-footer-component")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }